module.exports = __webpack_public_path__ + "static/top-04300aca011561e3552d54d723e3af9b.png";